module.exports = "/images/vendor/flag-icon-css/flags/4x3/es-ga.svg?2618e21f1cd5dcbd95d7b119f7b4e33a";